import type {SubTab} from '../modals/BuyersModal/create-buyer/CreateBuyerTabContent';
import type {CreateBuyerFormValues} from '../validation';
import type {UseFormReturn} from 'react-hook-form';

/** Leaving the buyer details for the FATCA/CRS step is gated on the roster validating. */
export function useBuyerSubTabNavigation(
  form: UseFormReturn<CreateBuyerFormValues>,
  setActiveSubTab: (tab: SubTab) => void
) {
  const handleContinue = form.handleSubmit(() => setActiveSubTab('fatca-crs'));

  const handleSubTabChange = (tab: SubTab) => {
    if (tab === 'fatca-crs') void handleContinue();
    else setActiveSubTab(tab);
  };

  return {handleContinue, handleSubTabChange};
}
